import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Separator } from "@/components/ui/separator";
import { useAuthState } from "@/context";
import { ToastMessage, type } from "@/lib/toastr";
import { cn } from "@/lib/utils";
import { addSomeone, changeRole } from "@/services/Settings.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, Loader2, UserPlus } from "lucide-react";
import { useState } from "react";
import { useForm } from "react-hook-form";

const Invite = () => {
  const queryClient = useQueryClient();
  const { state } = useAuthState();
  const mutation = useMutation({
    mutationFn: (data) => addSomeone(data),
    mutationKey: ["addSomeone"],
    onSuccess: (res) => {
      queryClient.clear();
      ToastMessage(
        type.SUCCESS,

        "invitation sent successfully"
      );

      setOpen(false);
    },
    onError: (err) => {
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const form = useForm();

  const onSubmit = async (formData) => {
    await mutation.mutate(formData);
  };
  const [open, setOpen] = useState(false);
  return (
    <Dialog
      open={open}
      onOpenChange={(e) => {
        setOpen(e);
        form?.reset();
      }}
    >
      <DialogTrigger asChild>
        <Button
          className="bg-gradient-to-r from-primary to-primary-2 ring-transparent focus-visible:ring-transparent"
          onClick={() => setOpen(true)}
          disabled={state?.merchant?.roleId === "merchant-staff"}
        >
          <UserPlus /> Invite
        </Button>
      </DialogTrigger>
      <DialogContent
        className={cn(
          "p-0 text-left items-start rounded-[4px] bg-background max-w-md overflow-auto h-[600px]"
        )}
      >
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-8 pb-8">
              <DialogHeader className="flex flex-row  w-full p-0 items-center gap-4 bg-off-white-1 py-6 px-8 rounded-t-[16px]">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-off-white-3">
                  <UserPlus />
                </div>
                <div className="flex flex-col ">
                  <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                    Invite Team Member
                  </DialogTitle>
                  <DialogDescription className="text-sm text-[#565C6B]">
                    Send a mail to someone you’d like to bring over
                  </DialogDescription>
                </div>
              </DialogHeader>
              <div className="flex flex-col gap-4 px-8 pb-2">
                <h4 className="text-base text-[#565C6B]">Personal Details</h4>
                {/* <FormField
                  control={form.control}
                  name="name"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div
                          className={cn(
                            "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-[52px]",
                            form.formState.errors?.phone === undefined
                              ? "border-input-border"
                              : "border-destructive"
                          )}
                        >
                          <div className="flex flex-col w-full">
                            <FormLabel className="text-xs text-[#696E7C]">
                              Team Member Name
                            </FormLabel>

                            <FormControl>
                              <Input
                                type="text"
                                className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                {...field}
                              />
                            </FormControl>
                          </div>
                        </div>
                        <FormMessage />
                      </FormItem>
                    );
                  }}
                /> */}
                <FormField
                  control={form.control}
                  name="email"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div
                          className={cn(
                            "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-[52px]",
                            form.formState.errors?.phone === undefined
                              ? "border-input-border"
                              : "border-destructive"
                          )}
                        >
                          <div className="flex flex-col w-full">
                            <FormLabel className="text-xs text-[#696E7C]">
                              Email
                            </FormLabel>

                            <FormControl>
                              <Input
                                type="email"
                                className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                {...field}
                              />
                            </FormControl>
                          </div>
                        </div>
                        <FormMessage />
                      </FormItem>
                    );
                  }}
                />
                {/* <FormField
                  control={form.control}
                  name="phone"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div
                          className={cn(
                            "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-[52px]",
                            form.formState.errors?.phone === undefined
                              ? "border-input-border"
                              : "border-destructive"
                          )}
                        >
                          <div className="flex flex-col w-full">
                            <FormLabel className="text-xs text-[#696E7C]">
                              Phone number
                            </FormLabel>

                            <FormControl>
                              <Input
                                type="text"
                                className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                {...field}
                              />
                            </FormControl>
                          </div>
                        </div>
                        <FormMessage />
                      </FormItem>
                    );
                  }}
                /> */}
                {/* <FormField
                  control={form.control}
                  name="password"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div
                          className={cn(
                            "flex w-full items-center gap-1.5 border-[1px]  rounded-[10px] px-4 py-2 h-[52px]",
                            form.formState.errors?.phone === undefined
                              ? "border-input-border"
                              : "border-destructive"
                          )}
                        >
                          <div className="flex flex-col w-full">
                            <FormLabel className="text-xs text-[#696E7C]">
                              Set password
                            </FormLabel>

                            <FormControl>
                              <Input
                                type="text"
                                className="w-full h-6 px-0 py-0 border-none outline-none placeholder:text-sm placeholder:font-medium ring-transparent focus-visible:ring-transparent focus:border-none"
                                {...field}
                              />
                            </FormControl>
                          </div>
                        </div>
                        <FormMessage />
                      </FormItem>
                    );
                  }}
                /> */}
              </div>
              <div className="px-8">
                <Separator />
              </div>
              <div className="flex flex-col gap-4 px-8 pb-2">
                <h4 className="text-base text-[#565C6B]">Assign Role</h4>
                <FormField
                  control={form.control}
                  name="roleId"
                  render={({ field }) => (
                    <FormItem className="space-y-3">
                      <FormControl>
                        <RadioGroup
                          onValueChange={field.onChange}
                          defaultValue={field.value}
                          className="grid grid-cols-2 gap-4"
                        >
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-admin" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Admin
                            </FormLabel>
                          </FormItem>
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-owner" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Owner
                            </FormLabel>
                          </FormItem>
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-developer" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Developer
                            </FormLabel>
                          </FormItem>
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-staff" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Staff
                            </FormLabel>
                          </FormItem>
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-business" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Business
                            </FormLabel>
                          </FormItem>
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-compliance" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Compliance
                            </FormLabel>
                          </FormItem>
                          <FormItem className="flex items-center space-x-3 space-y-0">
                            <FormControl>
                              <RadioGroupItem value="merchant-finance" />
                            </FormControl>
                            <FormLabel className="font-normal text-sm text-[#34373F]">
                              Finance
                            </FormLabel>
                          </FormItem>
                        </RadioGroup>
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              </div>
            </div>
            <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
              <DialogClose asChild>
                <Button
                  type="button"
                  variant="ghost"
                  className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                >
                  <ChevronLeft /> Cancel
                </Button>
              </DialogClose>
              <Button
                type="submit"
                className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
                disabled={
                  !form.formState.isDirty ||
                  !form.formState.isValid ||
                  form.formState.isSubmitting ||
                  mutation?.isPending
                }
              >
                {mutation?.isPending && (
                  <Loader2 className="text-white animate-spin" />
                )}
                Send Invite <ChevronRight />
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default Invite;